import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import Swal from "sweetalert2";
import IsLogin from "../../../Common/IsLogin";
import { ProgressSpinner } from "primereact/progressspinner";
import ReportDateRangeCsv from "../../../Common/ReportDateRangeCSV";

const DecorationFiringReport = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const [inputs, setInputs] = useState({
    date_from: getCurrentDate(),
    date_to: getCurrentDate(),
  });
  const [loading, setLoading] = useState(false);

  function getCurrentDate() {
    const dateObj = new Date();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();
    return `${year}-${month}-${day}`;
  }

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const fetchData = (dateFromParam, dateToParam) => {
    const dateFrom = dateFromParam || inputs.date_from || getCurrentDate();
    const dateTo = dateToParam || inputs.date_to || getCurrentDate();
    setLoading(true);
    Http.get(
      `/production-and-transfer-list?date_from=${dateFrom}&date_to=${dateTo}`,
    )
      .then((res) => {
        setReceiveData(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const formSubmit = () => {
    fetchData(inputs.date_from, inputs.date_to);
  };

  const calculateRowValues = (item) => {
    const receiveDataArr = item.receive_data || [];
    const productionData = item.production_data || [];
    const transferData = item.transfer_data || [];

    const receivedExport = receiveDataArr.reduce(
      (sum, r) => sum + Number(r.receive_qty_export || 0),
      0,
    );
    const receivedA = receiveDataArr.reduce(
      (sum, r) => sum + Number(r.receive_qty_a_class || 0),
      0,
    );
    const receivedB = receiveDataArr.reduce(
      (sum, r) => sum + Number(r.receive_qty_b_class || 0),
      0,
    );
    const receivedC = receiveDataArr.reduce(
      (sum, r) => sum + Number(r.receive_qty_c_class || 0),
      0,
    );

    // const producedExport = productionData.reduce(
    //   (sum, p) => sum + Number(p.qty_export || 0),
    //   0
    // );
    // const producedA = productionData.reduce(
    //   (sum, p) => sum + Number(p.qty_a_class || 0),
    //   0
    // );
    // const producedB = productionData.reduce(
    //   (sum, p) => sum + Number(p.qty_b_class || 0),
    //   0
    // );
    // const producedC = productionData.reduce(
    //   (sum, p) => sum + Number(p.qty_c_class || 0),
    //   0
    // );

    const transferredExport = transferData.reduce(
      (sum, t) =>
        sum +
        (t.is_return === 0 || t.is_return === undefined
          ? Number(t.delivery_qty_export || 0)
          : 0),
      0,
    );
    const transferredA = transferData.reduce(
      (sum, t) =>
        sum +
        (t.is_return === 0 || t.is_return === undefined
          ? Number(t.delivery_qty_a_class || 0)
          : 0),
      0,
    );
    const transferredB = transferData.reduce(
      (sum, t) =>
        sum +
        (t.is_return === 0 || t.is_return === undefined
          ? Number(t.delivery_qty_b_class || 0)
          : 0),
      0,
    );
    const transferredC = transferData.reduce(
      (sum, t) =>
        sum +
        (t.is_return === 0 || t.is_return === undefined
          ? Number(t.delivery_qty_c_class || 0)
          : 0),
      0,
    );

    const lossExport = productionData.reduce(
      (sum, p) => sum + Number(p.loss_qty_export || 0),
      0,
    );
    const lossA = productionData.reduce(
      (sum, p) => sum + Number(p.loss_qty_a_class || 0),
      0,
    );
    const lossB = productionData.reduce(
      (sum, p) => sum + Number(p.loss_qty_b_class || 0),
      0,
    );
    const lossC = productionData.reduce(
      (sum, p) => sum + Number(p.loss_qty_c_class || 0),
      0,
    );

    return {
      receivedExport,
      receivedA,
      receivedB,
      receivedC,
      // producedExport,
      // producedA,
      // producedB,
      // producedC,
      transferredExport,
      transferredA,
      transferredB,
      transferredC,
      lossExport,
      lossA,
      lossB,
      lossC,
    };
  };

  const totals = receiveData.reduce(
    (acc, item) => {
      const {
        receivedExport,
        receivedA,
        receivedB,
        receivedC,
        // producedExport,
        // producedA,
        // producedB,
        // producedC,
        transferredExport,
        transferredA,
        transferredB,
        transferredC,
        lossExport,
        lossA,
        lossB,
        lossC,
      } = calculateRowValues(item);

      return {
        totalReceivedExport: acc.totalReceivedExport + receivedExport,
        totalReceivedA: acc.totalReceivedA + receivedA,
        totalReceivedB: acc.totalReceivedB + receivedB,
        totalReceivedC: acc.totalReceivedC + receivedC,
        // totalProducedExport: acc.totalProducedExport + producedExport,
        // totalProducedA: acc.totalProducedA + producedA,
        // totalProducedB: acc.totalProducedB + producedB,
        // totalProducedC: acc.totalProducedC + producedC,
        totalTransferredExport: acc.totalTransferredExport + transferredExport,
        totalTransferredA: acc.totalTransferredA + transferredA,
        totalTransferredB: acc.totalTransferredB + transferredB,
        totalTransferredC: acc.totalTransferredC + transferredC,
        totalLossExport: acc.totalLossExport + lossExport,
        totalLossA: acc.totalLossA + lossA,
        totalLossB: acc.totalLossB + lossB,
        totalLossC: acc.totalLossC + lossC,
      };
    },
    {
      totalReceivedExport: 0,
      totalReceivedA: 0,
      totalReceivedB: 0,
      totalReceivedC: 0,
      // totalProducedExport: 0,
      // totalProducedA: 0,
      // totalProducedB: 0,
      // totalProducedC: 0,
      totalTransferredExport: 0,
      totalTransferredA: 0,
      totalTransferredB: 0,
      totalTransferredC: 0,
      totalLossExport: 0,
      totalLossA: 0,
      totalLossB: 0,
      totalLossC: 0,
    },
  );

  const getCsvData = () => {
    const headers = [
      "Name of Ware",
      "Shape",
      "Glaze",
      "Decoration",
      "Received Export",
      "Received A",
      "Received B",
      "Received C",
      "Transferred Export",
      "Transferred A",
      "Transferred B",
      "Transferred C",
      "Loss Export",
      "Loss A",
      "Loss B",
      "Loss C",
    ];

    const rows = receiveData.map((item) => {
      const {
        receivedExport,
        receivedA,
        receivedB,
        receivedC,
        transferredExport,
        transferredA,
        transferredB,
        transferredC,
        lossExport,
        lossA,
        lossB,
        lossC,
      } = calculateRowValues(item);
      return [
        item.product_name,
        item.shape,
        item.glaze,
        `${item.decoration_code} (${item.decoration_name})`,
        receivedExport,
        receivedA,
        receivedB,
        receivedC,
        transferredExport,
        transferredA,
        transferredB,
        transferredC,
        lossExport,
        lossA,
        lossB,
        lossC,
      ];
    });

    const footerRows = [
      [
        "",
        "",
        "",
        "Total",
        totals.totalReceivedExport,
        totals.totalReceivedA,
        totals.totalReceivedB,
        totals.totalReceivedC,
        totals.totalTransferredExport,
        totals.totalTransferredA,
        totals.totalTransferredB,
        totals.totalTransferredC,
        totals.totalLossExport,
        totals.totalLossA,
        totals.totalLossB,
        totals.totalLossC,
      ],
    ];

    return { headers, rows, footerRows };
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Decoration Firing Report</h5>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <ReportDateRangeCsv
                dateFrom={inputs.date_from}
                dateTo={inputs.date_to}
                onChange={handleChange}
                onSearch={formSubmit}
                csvFilename={`decoration-firing-report_${inputs.date_from}_to_${inputs.date_to}.csv`}
                getCsvData={getCsvData}
              />
            </div>
          </div>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <h5 className="text-uppercase text-sm font-weight-bolder">
                      Artisan Ceramics Limited
                    </h5>
                    <p>
                      House-16, Road-07, Sector-01, Uttara, Dhaka
                      <br />
                      <b>Decoration Firing Report</b>
                    </p>
                  </div>
                  <div
                    className="table-responsive p-0 pb-2"
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                  >
                    <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 _datatable">
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: "#fff",
                        }}
                      >
                        <tr>
                          <th
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2"
                            rowSpan={2}
                          >
                            Name of Ware
                          </th>
                          <th
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                            rowSpan={2}
                          >
                            Shape
                          </th>
                          <th
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                            rowSpan={2}
                          >
                            Glaze
                          </th>
                          <th
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                            rowSpan={2}
                          >
                            Decoration
                          </th>
                          {/* <th
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                            rowSpan={2}
                          >
                            Decoration Name
                          </th> */}
                          <th
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                            colSpan={4}
                          >
                            Received
                          </th>
                          {/* <th
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                            colSpan={4}
                          >
                            Produced
                          </th> */}
                          <th
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                            colSpan={4}
                          >
                            Transferred
                          </th>
                          <th
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                            colSpan={4}
                          >
                            Loss
                          </th>
                        </tr>
                        <tr>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Export
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            A
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            B
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            C
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Export
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            A
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            B
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            C
                          </th>
                          {/* <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Export
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            A
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            B
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            C
                          </th> */}
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Export
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            A
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            B
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            C
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td
                              className="text-center"
                              colSpan={16}
                              style={{ padding: "2rem" }}
                            >
                              <ProgressSpinner
                                style={{ width: "40px", height: "40px" }}
                                strokeWidth="4"
                              />
                            </td>
                          </tr>
                        ) : receiveData && receiveData.length > 0 ? (
                          receiveData.map((item, index) => {
                            const {
                              receivedExport,
                              receivedA,
                              receivedB,
                              receivedC,
                              // producedExport,
                              // producedA,
                              // producedB,
                              // producedC,
                              transferredExport,
                              transferredA,
                              transferredB,
                              transferredC,
                              lossExport,
                              lossA,
                              lossB,
                              lossC,
                            } = calculateRowValues(item);

                            return (
                              <tr key={index}>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {item.product_name}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {item.shape}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {item.glaze}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {item.decoration_code} ({item.decoration_name}
                                  )
                                </td>
                                {/* <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {item.decoration_name}
                                </td> */}
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {receivedExport}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {receivedA}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {receivedB}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {receivedC}
                                </td>
                                {/* <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {producedExport}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {producedA}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {producedB}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {producedC}
                                </td> */}
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {transferredExport}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {transferredA}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {transferredB}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {transferredC}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {lossExport}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {lossA}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {lossB}
                                </td>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {lossC}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                              colSpan={5 + 4 * 4}
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2"
                            colSpan={4}
                          >
                            Total
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalReceivedExport}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalReceivedA}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalReceivedB}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalReceivedC}
                          </td>
                          {/* <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalProducedExport}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalProducedA}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalProducedB}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalProducedC}
                          </td> */}
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalTransferredExport}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalTransferredA}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalTransferredB}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalTransferredC}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalLossExport}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalLossA}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalLossB}
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            {totals.totalLossC}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DecorationFiringReport;
